import React from "react";

import styled from "@mui/material/styles/styled";

import LogomarkIcon from "@readai/icons/brand/LogomarkIcon";
import Stack, { StackProps } from "@readai/pulse/components/Stack";
import { px } from "@readai/pulse/utils";

interface LogomarkWithGradientProps extends StackProps {
  size?: number;
}

const Wrapper = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(0.75),
  borderRadius: theme.corners.small,
  flexShrink: 0,
  background: theme.palette.gradients.read,
}));

const LogomarkWithGradient = ({ size = 36, sx }: LogomarkWithGradientProps) => (
  <Wrapper sx={{ height: px(size), width: px(size), ...sx }}>
    <LogomarkIcon sx={{ height: "100%", width: "100%" }} />
  </Wrapper>
);

export default LogomarkWithGradient;
